// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"2e8387fe","764":"67c1fb5a","881":"798c549d","947":"8f16a5ea"}[chunkId] + ".chunk.js";
};